import { ICalSubscriptionUrls, SyncWriteResponse, V3ICalSubscriptionTask } from '@crewmeister/shared/src/types';
import produce from 'immer';
import { CALENDAR_OPTIONS } from '@crewmeister/shared/src/types/v3/calendar-options';
import { ACTION_NAMES } from '../../constants';

type V3ICalSubscriptionTaskAction = {
  type: string;
  crewId: number;
  userId: number;
  result: SyncWriteResponse<V3ICalSubscriptionTask, string>;
};

type V3ICalSubscriptionUrlsInRedux = {
  iCalSubscriptionUrls: ICalSubscriptionUrls;
};

export const v3ICalSubscriptionUrlsReducer = (
  state: V3ICalSubscriptionUrlsInRedux = {
    iCalSubscriptionUrls: {
      [CALENDAR_OPTIONS.APPLE]: '',
      [CALENDAR_OPTIONS.GOOGLE]: '',
      [CALENDAR_OPTIONS.OUTLOOK]: '',
      [CALENDAR_OPTIONS.OTHER]: '',
    },
  },
  action: V3ICalSubscriptionTaskAction
): V3ICalSubscriptionUrlsInRedux =>
  produce(state, (draft: V3ICalSubscriptionUrlsInRedux) => {
    switch (action.type) {
      case `${ACTION_NAMES.V3_READ_ICAL_SUBSCRIPTION_URLS}_REQUEST`:
        // Unset the error flag when the request starts
        // Disable ESLint rule for this line to allow direct assignment,
        // because immer draft is always mutable.
        // eslint-disable-next-line no-param-reassign
        draft.iCalSubscriptionUrls = {
          [CALENDAR_OPTIONS.APPLE]: '',
          [CALENDAR_OPTIONS.GOOGLE]: '',
          [CALENDAR_OPTIONS.OUTLOOK]: '',
          [CALENDAR_OPTIONS.OTHER]: '',
          error: false,
          loading: true,
        };
        break;
      case `${ACTION_NAMES.V3_READ_ICAL_SUBSCRIPTION_URLS}_SUCCESS`:
        if (action.result.resourceAfterWrite?.output?.feedURL) {
          const feedUrl = action.result.resourceAfterWrite.output.feedURL;
          // Disable ESLint rule for this line to allow direct assignment,
          // because immer draft is always mutable.
          // eslint-disable-next-line no-param-reassign
          draft.iCalSubscriptionUrls = feedUrlToIcalSubscription(feedUrl);
        }
        break;
      case `${ACTION_NAMES.V3_READ_ICAL_SUBSCRIPTION_URLS}_FAILURE`:
        // If the action fails, we can set the error flag to true
        // Disable ESLint rule for this line to allow direct assignment,
        // because immer draft is always mutable.
        // eslint-disable-next-line no-param-reassign
        draft.iCalSubscriptionUrls = {
          [CALENDAR_OPTIONS.APPLE]: '',
          [CALENDAR_OPTIONS.GOOGLE]: '',
          [CALENDAR_OPTIONS.OUTLOOK]: '',
          [CALENDAR_OPTIONS.OTHER]: '',
          error: true,
          loading: false,
        };
        break;
      default:
        // No action needed for other cases
        break;
    }
  });

const feedUrlToIcalSubscription = (feedUrl: string): ICalSubscriptionUrls => {
  const webcalUrl = feedUrl.replace(/^https?:/i, 'webcal:');
  return {
    [CALENDAR_OPTIONS.APPLE]: webcalUrl,
    [CALENDAR_OPTIONS.GOOGLE]: `https://calendar.google.com/calendar/r?cid=${encodeURIComponent(webcalUrl)}`,
    [CALENDAR_OPTIONS.OUTLOOK]: `https://outlook.office.com/calendar/0/addfromweb?url=${encodeURIComponent(feedUrl)}`,
    [CALENDAR_OPTIONS.OTHER]: feedUrl,
    error: false,
    loading: false,
  };
};
